import React from 'react';
import { fComp } from '../../utils/React.js';
import { TogglePresentation } from '../Toggle/TogglePresentation.js';
import { hostClass } from './Checkbox.styles.js';

var defaultProps = {
  onChange: function onChange() {
    /* empty */
  }
};
var CheckboxPresentation = fComp(function (props) {
  var value = props.value;
  var indeterminate = value === undefined;
  return /*#__PURE__*/React.createElement(TogglePresentation, Object.assign({}, props, {
    hostClass: hostClass,
    type: "checkbox",
    indeterminate: indeterminate
  }), !indeterminate && /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16",
    className: "".concat(hostClass, "-svg")
  }, /*#__PURE__*/React.createElement("path", {
    className: "".concat(hostClass, "-path"),
    fill: "none",
    stroke: "transparent",
    strokeWidth: 2.5,
    d: "M2,8 6,12 14,4"
  })), indeterminate && /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 16 16",
    className: "".concat(hostClass, "-svg")
  }, /*#__PURE__*/React.createElement("path", {
    className: "".concat(hostClass, "-path"),
    fill: "none",
    stroke: "transparent",
    strokeWidth: 3,
    d: "M2,8 14,8"
  })));
}, defaultProps);
CheckboxPresentation.displayName = "CheckboxPresentation";

export { CheckboxPresentation, defaultProps };
